export default "__VITE_ASSET__6d6da698__"